'use client'

import { GET_USER_INVITE } from '@/modules/invite/queries'
import { Query } from '@/lib/generated/graphql-types'
import { MainRoutes } from '@/utils/routes'
import posthog from 'posthog-js'
import { useQuery } from '@apollo/client'

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL

export function useInviteLink({
  isAuthenticated,
}: {
  isAuthenticated: boolean
}) {
  const { data, loading } = useQuery<Pick<Query, 'getUserInvite'>>(
    GET_USER_INVITE,
    { skip: !isAuthenticated },
  )
  const { token } = data?.getUserInvite ?? {}
  let currentUrl: URL | null = null
  if (typeof window === 'undefined') {
    return {
      inviteUrl: '',
      loading: true,
    }
  }
  try {
    currentUrl = new URL(window.location.href)
  } catch (e) {
    posthog.captureException(
      `Error while generating invite link from give-to-get: ${e}`,
    )
  }
  return {
    inviteUrl: `${currentUrl?.origin ?? BASE_URL ?? ''}${MainRoutes.Invite}/${token}`,
    token,
    loading,
  }
}
